import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const LegalLayout = ({ title, subtitle, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#08080a] text-white">
      <div className="noise-overlay fixed inset-0 z-[100]" />
      {/* Header */}
      <div className="relative border-b border-white/8 bg-[#0b0b0e]">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm mb-6"
          >
            <ArrowLeft size={16} /> Retour à l'accueil
          </Link>
          <div className="flex items-center gap-2 mb-3">
            <ShieldCheck size={18} className="text-[#ff6a00]" />
            <span className="eyebrow !text-[#ff5a1f]">{subtitle}</span>
          </div>
          <h1 className="section-title text-3xl md:text-5xl">{title}</h1>
          {updated && (
            <p className="mt-3 text-white/45 text-sm">Dernière mise à jour : {updated}</p>
          )}
        </div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto px-5 md:px-8 py-12 legal-content"
      >
        {children}
      </motion.div>

      {/* Footer */}
      <div className="border-t border-white/8 py-8">
        <div className="max-w-4xl mx-auto px-5 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} BS Import Auto. Tous droits réservés.
          </p>
          <div className="flex gap-5 text-sm">
            <Link to="/mentions-legales" className="text-white/50 hover:text-[#ff6a00] transition-colors">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-white/50 hover:text-[#ff6a00] transition-colors">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

// Small helpers for consistent typography
export const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">{title}</h2>
    <div className="space-y-3 text-white/65 leading-relaxed text-[15px]">{children}</div>
  </section>
);

export const Placeholder = ({ children }) => (
  <span className="text-[#ff8a4c] font-medium">{children}</span>
);

export default LegalLayout;
